<div class="templates-page" id="templates-container">
    <h5 class="p-16 m-0 bottomBorderStyle">{{isSubfolderLevel ? 'Subfolder Templates' : 'Folder Templates'}}<span class="count-icon count-icon-padding font-s m-l-s">{{templatesCount}}</span></h5>
    <div>
        <app-dynamic-table [columnList]="columnList"  [tableItems]="tableItems" tableHeightInVh="72.5" tableWidthInVw="22" borderSizeInPx="5" [hoverDisplay]="false" [hideHeader]="true" noItemsErrorMessage="No Templates to be displayed"
            (clickedRowData)="clickedData($event)"
        ></app-dynamic-table>
    </div>
</div>